import { createResource } from 'react-resource-router';
import { getGlobalPolicies, getNotificationPolicies, getPolicyMaintenanceRights, getTeamPolicies } from '../endpoints';
export const teamPolicyResource = createResource({
  type: 'teamPolicyResource',
  getKey: routerContext => {
    var _routerContext$match$;
    const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
    return `team-policy/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
  },
  getData: async routerContext => {
    var _routerContext$match$2;
    const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;

    // if there is no teamId, this means that we are on the global policy page.
    // so we can return null directly, instead of sending fetch request.
    if (!teamId) {
      return null;
    }
    return getTeamPolicies(teamId);
  },
  isBrowserOnly: true
});
export const notificationPolicyResource = createResource({
  type: 'notificationPolicyResource',
  getKey: routerContext => {
    var _routerContext$match$3;
    const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
    return `notification-policy/${teamId}`;
  },
  getData: async routerContext => {
    var _routerContext$match$4;
    const teamId = (_routerContext$match$4 = routerContext.match.params) === null || _routerContext$match$4 === void 0 ? void 0 : _routerContext$match$4.teamId;
    if (!teamId) {
      return;
    }
    return getNotificationPolicies(teamId);
  },
  isBrowserOnly: true
});
export const globalPolicyResource = createResource({
  type: 'globalPolicyResource',
  getKey: routerContext => {
    var _routerContext$match$5;
    const teamId = (_routerContext$match$5 = routerContext.match.params) === null || _routerContext$match$5 === void 0 ? void 0 : _routerContext$match$5.teamId;
    if (teamId) {
      return `global-policy/${teamId}`;
    }
    return 'global-policy';
  },
  getData: async routerContext => {
    var _routerContext$match$6;
    const teamId = (_routerContext$match$6 = routerContext.match.params) === null || _routerContext$match$6 === void 0 ? void 0 : _routerContext$match$6.teamId;
    return getGlobalPolicies(teamId);
  },
  isBrowserOnly: true
});
export const policyMaintenanceRightsResource = createResource({
  type: 'policyMaintenanceRightsResource',
  getKey: () => 'policy-maintenance-rights-resource',
  getData: async () => {
    return getPolicyMaintenanceRights();
  },
  isBrowserOnly: true
});
export const resources = [teamPolicyResource, globalPolicyResource, policyMaintenanceRightsResource, notificationPolicyResource];